import KeywordListModal from './KeywordListModal.vue';

export default KeywordListModal;
